import { render, staticRenderFns } from "./VocabularyManagerForm.vue?vue&type=template&id=0eda1a42&"
import script from "./VocabularyManagerForm.vue?vue&type=script&lang=ts&"
export * from "./VocabularyManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports